import React from 'react';
import {EnrollmentApplicationTemplateType} from 'Enrollment/ducks/enrollmentFileProcessing';
import FileDownloadLink, {FileExtension} from 'Shared/components/FileDownloadLink';
import {EnrollmentApplicationTemplate} from 'Enrollment/models/EnrollmentApplicationTemplate';

type EnrollmentApplicationTemplateDownloadSectionProps = {
  template: EnrollmentApplicationTemplate;
};

const EnrollmentApplicationTemplateDownloadSection = (props: EnrollmentApplicationTemplateDownloadSectionProps) => {
  const {template} = props;
  const {id, name, documentFriendlyName} = template;

  return id === EnrollmentApplicationTemplateType.BrokerSpreadsheet ? (
    <div className="enrollment-file-upload-modal__template">
      <div className="enrollment-file-upload-modal__template-content">
        <span className="enrollment-file-upload-modal__template-content__title">
          <u>Template:</u>
        </span>
        <span className="enrollment-file-upload-modal__template-content__value">
          <FileDownloadLink
            downloadedFileName={documentFriendlyName!}
            extension={FileExtension.XLSX}
            relativeFileLocation={`/documents/${documentFriendlyName}/export/${FileExtension.XLSX.toLowerCase().replace(
              '.',
              ''
            )}`}
          >
            {name!}
          </FileDownloadLink>
        </span>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default EnrollmentApplicationTemplateDownloadSection;
